import { IsNumber } from "class-validator";

export default class TransmedRegistrationRank {
  @IsNumber() public readonly points!: number;
}
